module.exports = __webpack_public_path__ + "static/img/10.f23fe0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/10.png
// module id = pO7D
// module chunks = 0